app.components.slideshow_video = {
    onReady: function () {
        if ($('.slideshow_video').length) {
            return true;
        }
    },
    addListener: function () {
        this.initalizeGallery();
        this.initalizeSlideshow();
    },

    initalizeGallery: async function () {
        try {
            const Fancyapps = await import('@fancyapps/ui');
            await import('@fancyapps/ui/dist/fancybox/fancybox.css');

            const lang = document.documentElement.lang;
            let closeButtonText = "Schliessen";
            if (lang.includes('fr')) {
                closeButtonText = "Fermer";
            } else if (lang.includes('it')) {
                closeButtonText = "Chiudi";
            }

            Fancyapps.Fancybox.bind('[data-fancybox="video-gallery"]', {
                infinite: true,
                animated: true,
                mainClass: "video-player-styles",
                video: {
                    autoplay: false,
                },
                tpl: {
                    closeButton: `<button  data-fancybox-close class='button-tertiary'>${closeButtonText}<i class='icon-close'></i></button>`,
                },
                dragToClose: true,
                keyboard: {
                    Escape: "close",
                    ArrowLeft: "prev",
                    ArrowRight: "next",
                },
                Toolbar: {
                    display: [
                        "close",
                        "prev",
                        "next",
                    ]
                },
                Hash: false,
                Thumbs: false
            });

        } catch (error) {
            console.error('Error loading modules:', error)
        }
    },

    nInitialVideos: 0,

    initalizeSlideshow: function () {
        const track = document.querySelector('.slideshow_video .track');
        if (track) {
            const items = Array.from(track.children);
            this.nInitialVideos = items.length;

            // Calculate total width of original items including margins
            const itemTotalWidth = this.calcItemsTotalWidth(items);

            // Ensure enough items to cover screen width twice for seamless scroll
            const viewportWidth = window.innerWidth;
            let currentWidth = itemTotalWidth;

            while (currentWidth < viewportWidth + itemTotalWidth) {
                items.forEach(item => {
                    const clone = item.cloneNode(true);
                    track.appendChild(clone);
                });
                currentWidth += itemTotalWidth;
            }

            // Create keyframes for scrolling animation
            const animationName = 'scrollTrackAnimation';
            const speedPxPerSec = 50;
            const duration = itemTotalWidth / speedPxPerSec;

            const keyframes = `
                @keyframes ${animationName} {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-${itemTotalWidth}px); }
                }
            `;

            const styleEl = document.createElement('style');
            styleEl.textContent = keyframes;
            document.head.appendChild(styleEl);


            // Apply animation styles to track
            track.style.animation = `${animationName} ${duration}s linear infinite`;
            track.style.display = 'flex';
            track.style.whiteSpace = 'nowrap';
        }
    },

    calcItemsTotalWidth: function (items) {
        return items.reduce((total, item) => {
            const style = getComputedStyle(item);
            const marginRight = parseFloat(style.marginRight) || 0;
            return total + item.offsetWidth + marginRight;
        }, 0);
    },
    resize: function () {
        const track = document.querySelector('.slideshow_video .track');
        const initialItems = Array.from(track.children).slice(0, this.nInitialVideos);
        const initialItemsWidth = this.calcItemsTotalWidth(initialItems);
        const viewportWidth = window.innerWidth;
        let currentWidth = this.calcItemsTotalWidth(Array.from(track.children));
        while (currentWidth < viewportWidth + initialItemsWidth) {
            initialItems.forEach(item => {
                const clone = item.cloneNode(true);
                track.appendChild(clone);
            });
            currentWidth += initialItemsWidth;
        }
    }
};
